import React from "react";
import { Avatar as AntdAvatar } from "antd";
import classNames from "classnames";

// interfaces
import { IAvatar, TAvatarColor } from "./IAvatar";

// assets
import styles from "@/assets/styles/components/avatar.module.scss";


function Avatar({ className, fullName = "", email, size = "medium", showFullInfo, additionalInfo, color, ...props }: IAvatar) {
  const [firstName = "", lastName = ""] = fullName.split(" ");
  const initials = (firstName[0] || "") + (lastName[0] || "");

  const avatarClassName = classNames(
    styles["locl-avatar"],
    className,
    "locl-avatar",
    styles[`locl-avatar_size-${size}`],
    { [styles[`locl-avatar_color-${color as TAvatarColor}`]]: color }
  );

  return (
    <div className={avatarClassName} data-testid="locl-avatar">
      <AntdAvatar
        {...props}
        alt={`Avatar of ${fullName}`}
        className={styles["locl-avatar__inner"]}
      >
        {initials.toUpperCase()}
      </AntdAvatar>
      {showFullInfo && (
        <div className={styles["locl-avatar__main-info"]} data-testid="locl-avatar-main-info">
          {fullName ? (
            <p className={styles["locl-avatar__full-name"]} data-testid="locl-avatar-full-name">
              {fullName}
            </p>
          ) : null}
          {email ? (
            <a href={`mailto:${email}`} className={styles["locl-avatar__email"]} data-testid="locl-avatar-email">
              {email}
            </a>
          ) : null}
          {!!additionalInfo && additionalInfo}
        </div>
      )}
    </div>
  );
}

export default Avatar;
